export enum SlideState {
    START,
    END,
  }
  
  export type SlideEvent = { slideIn: string, slideOut: string, state: SlideState };